import apiClient from '../client';
import { Invoice, Task, ApiResponse } from '@/types';

interface InvoiceListResponse {
  invoices?: Invoice[];
  tasks?: Task[];
  tasksByClient?: Record<string, Task[]>;
  pagination: {
    total: number;
    pages: number;
    page: number;
    limit: number;
  };
}

interface InvoiceResponse {
  invoice?: Invoice;
  requiresBusinessDetails?: boolean;
  clientId?: string;
  missingFields?: Record<string, boolean>;
}

export const invoicesApi = {
  getInvoices: (params?: Record<string, any>) => 
    apiClient.get<ApiResponse<InvoiceListResponse>>('/invoices', { params }),
  
  getInvoice: (id: string) => 
    apiClient.get<ApiResponse<InvoiceResponse>>(`/invoices/${id}`),
  
  generateFromTasks: (data: {
    taskIds: string[];
    clientName: string;
    dueDate: string;
    notes?: string;
  }) => apiClient.post<ApiResponse<InvoiceResponse>>('/invoices/generate-from-tasks', data),
  
  updateClientAndGenerate: (data: {
    clientId: string;
    address: string;
    gst: string;
    taskIds: string[];
    dueDate: string;
  }) => apiClient.post<ApiResponse<InvoiceResponse>>('/invoices/update-client-and-generate', data),
  
  downloadInvoice: (id: string) => 
    apiClient.get(`/invoices/${id}/download`, { 
      responseType: 'blob'
    }),
    
  sendInvoice: (id: string, email: string, cc?: string[], message?: string) => 
        apiClient.post<ApiResponse<void>>(`/invoices/${id}/send`, { email, cc, message }),
  
  revertInvoice: (id: string) =>
    apiClient.delete<ApiResponse<void>>(`/invoices/${id}/revert`),
    
  markAsDone: (id: string) =>
    apiClient.put<ApiResponse<InvoiceResponse>>(`/invoices/${id}/done`, {}),
    
  updateStatus: (id: string, status: string) =>
    apiClient.put<ApiResponse<InvoiceResponse>>(`/invoices/${id}/status`, { status }),
    
  recordPayment: (id: string, data: {
    amount: number;
    paymentDate?: string;
    method: string;
    reference?: string;
  }) => apiClient.post<ApiResponse<InvoiceResponse>>(`/invoices/${id}/payment`, data)
};